import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService, BooleanBaseResponse, CoreService, LoginModel, LoginResultModelBaseResponse } from '../../services/api-services';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthSubscriptionService, BaseComponent, ClaimTypes, LocalStorageWrapper, TranslatedToastrService, ValidationHandlerService, FrontendDisplayHtmlType } from 'lib/Vestra.shared';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';
import { Subscription } from 'rxjs';
import { BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    templateUrl: './login-user.component.html',
    styleUrls: ['./login-user.component.scss'],
})
export class LoginUserComponent extends BaseComponent implements OnInit {
    public appVersion: string = '1.0.21';
    public type: FrontendDisplayHtmlType = FrontendDisplayHtmlType.LoginUserInfo;

    private returnUrl: string;
    private subscription?: Subscription;

    loginForm: FormGroup;
    constructor(private translatedToastrService: TranslatedToastrService, private coreService: CoreService, private authenticationService: AuthenticationService, private router: Router, private route: ActivatedRoute, protected override validationHandlerService: ValidationHandlerService, protected override modalService: BsModalService, protected override spinnerService: NgxSpinnerService, private authSubscriptionService: AuthSubscriptionService) {
        super(spinnerService, modalService, validationHandlerService);
    }

    public ngOnInit(): void {
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '';
        if (this.authenticationService.isUserAuthenticated()) {
            this.router.navigate([this.returnUrl || 'home']);
        }

        this.subscription = this.authSubscriptionService.authChanged.subscribe(res => {
            if (res) {
                this.router.navigate([this.returnUrl || 'home']);
            }
        });

        this.loginForm = new FormGroup({
            email: new FormControl('', [Validators.required, Validators.email]),
            password: new FormControl('', [Validators.required]),
        });
        this.getVersion();
    }

    public getVersion() {
        firstValueFrom(this.coreService.getAndCheckAppVersion(this.appVersion, false))
            .then((res: BooleanBaseResponse) => {
                if (!res.result) {
                    this.translatedToastrService.warning(res.message, 'common.warning');
                    this.loginButtonDisable = true;

                    this.clearAllStorage();
                }
            })
            .catch((err: HttpErrorResponse) => {
                this.loginButtonDisable = true;
            });
    }

    public ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    public loginButtonDisable: boolean = false;
    public login = async (): Promise<any> => {
        if (this.validationHandlerService.checkFormValid(this.loginForm)) {
            this.loginButtonDisable = true;
            const login = this.loginForm.getRawValue();
            const userForAuth: LoginModel = {
                email: login.email,
                password: login.password,
                returnUrl: this.returnUrl,
                appVersion: this.appVersion,
                isPublicSite: false,
            };

            return this.handleSpinner(
                firstValueFrom(this.authenticationService.login(userForAuth))
                    .then((res: LoginResultModelBaseResponse) => {
                        LocalStorageWrapper.setToken(res.result.token);
                        let dToken = this.authenticationService.getDecodedToken();
                        LocalStorageWrapper.setUserDisplayName(dToken[ClaimTypes.Name]);
                        this.authSubscriptionService.sendAuthStateChangeNotification(res.isSuccess);
                        this.router.navigate([this.returnUrl || 'home']);
                        return Promise.resolve(res);
                    })
                    .catch((err: HttpErrorResponse) => {
                        if (err.message === 'InvalidVersion') {
                            this.translatedToastrService.warning('common.invalid_version', 'common.warning');
                            setTimeout(() => {
                                this.clearAllStorage();
                            }, 2500);
                        } else {
                            this.validationHandlerService.handleServerError(err, this.loginForm);
                            this.loginButtonDisable = false;
                        }
                    })
            );
        }
    };

    private clearAllStorage() {
        localStorage.clear();
        sessionStorage.clear();

        window.location.reload();
    }
}
